import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';

import { getTotalVoted } from '../../../shared/services/ResultsService';
import { SocialButtons } from '../../../shared/components/SocialButtons';
import { telegramBotUrl, viberBotUrl } from '../../../../globals';
import CoordinationCouncilLogo from '../../../shared/components/CoordinationCouncilLogo';
import Counter from '../../../shared/components/Counter';
import HashLink from '../../../shared/components/HashLink';
import HonestPeopleLogo from '../../../shared/components/HonestPeopleLogo';
import Icon from '../../../shared/components/Icon';
import IconLibra from '../../../assets/images/icon-libra.svg';
import List from '../../../shared/components/List';
import Loading from '../../../shared/components/Loading';
import OneCol from '../../../shared/structure/OneCol';
import Paragraph from '../../../shared/components/Paragraph';
import Section from '../../../shared/components/Section';
import Separator from '../../../shared/structure/Separator';
import ThreeCols from '../../../shared/structure/ThreeCols';
import TrustVoiceSection from '../../../shared/components/TrustVoiceSection';
import TwoCols from '../../../shared/structure/TwoCols';
import VoiceLink from '../../../shared/components/Link';
import VoiceLogo from '../../../shared/components/VoiceLogo';

const useStyles = makeStyles((theme) => ({
  marginLeft: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));

export default function ConstitutionContainer() {
  const { t } = useTranslation();
  const [total, setTotal] = useState(null);
  const [totalLoaded, setTotalLoaded] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    getTotalVoted().then(
      (_totalVoted) => {
        setTotal(_totalVoted);
        setTotalLoaded(true);
      },
    );
  }, []);

  return (
    <>
      <Section
        background="blue"
        content={(
          <>
            <OneCol
              span={12}
              col={(
                <Paragraph
                  title={t('const_main_title')}
                />
              )}
            />
            <TwoCols
              left={(
                <>
                  <Paragraph>
                    {t('const_main_p_1')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_main_p_2')}
                  </Paragraph>
                  <List>
                    <li>{t('const_main_list_1')}</li>
                    <li>{t('const_main_list_2')}</li>
                    <li>{t('const_main_list_3')}</li>
                  </List>
                  <Paragraph bold>
                    {t('const_main_p_3')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_main_p_4')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_main_p_5')}
                  </Paragraph>
                  <List numbered>
                    <li>{t('const_main_list_2_1')}</li>
                    <li>{t('const_main_list_2_2')}</li>
                  </List>
                  <Paragraph bold>
                    {t('const_main_p_6')}
                    <VoiceLink
                      href={viberBotUrl}
                      underline="always"
                    >
                      Viber
                    </VoiceLink>
                    {t('const_main_p_6_1')}
                    <VoiceLink
                      href={telegramBotUrl}
                      underline="always"
                    >
                      Telegram
                    </VoiceLink>
                    {t('const_main_p_6_2')}
                  </Paragraph>

                  <SocialButtons />
                </>
              )}
              right={(
                <>
                  <Box
                    ml={3}
                    className={classes.marginLeft}
                  >
                    {totalLoaded ? (
                      <Counter
                        title={t('const_us_already')}
                        total={total.TotalVoted || 0}
                        color="white"
                      />
                    ) : <Loading />}

                    <Separator
                      background="blue"
                    />

                    {totalLoaded ? (
                      <Counter
                        title={t('voted_for_constitution')}
                        total={total.TotalVotedForConsitutionInBY || 0}
                      />
                    ) : <Loading />}

                    <Separator
                      background="blue"
                    />

                    <Paragraph>
                      <HashLink
                        color="white"
                        to="#anchor"
                        big
                      >
                        {t('const_why_trust')}
                      </HashLink>
                    </Paragraph>
                  </Box>
                </>
              )}
            />
          </>
        )}
      />

      <Section
        content={(
          <>
            <ThreeCols
              leftAlign="center"
              centerAlign="center"
              rightAlign="center"
              alignItems="center"
              left={(
                <VoiceLogo />
              )}
              center={(
                <CoordinationCouncilLogo
                  small
                />
              )}
              right={(
                <HonestPeopleLogo />
              )}
            />
          </>
        )}
      />

      <Separator
        background="gray"
      />

      <Section
        content={(
          <>
            <TwoCols
              leftSpan={4}
              rightSpan={8}
              alignItems="center"
              left={(
                <>
                  <SocialButtons
                    flexDirection="column"
                  />
                </>
              )}
              right={(
                <>
                  <Paragraph
                    title={t('walking_how_title')}
                  >
                    {t('const_howitworks_p_1')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_howitworks_p_2')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_howitworks_p_3')}
                  </Paragraph>
                </>
              )}
            />
          </>
        )}
      />

      <Section
        background="gray"
        content={(
          <>
            <TwoCols
              leftSpan={9}
              rightSpan={3}
              left={(
                <>
                  <Paragraph
                    title={t('const_whychange_title')}
                  >
                    {t('const_whychange_p_1')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_whychange_p_2')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_whychange_p_3')}
                  </Paragraph>
                  <Paragraph>
                    {t('const_whychange_p_4')}
                  </Paragraph>
                </>
              )}
              right={(
                <Icon
                  src={IconLibra}
                  alt={t('landing_card_icon_alt_1')}
                />
              )}
            />
          </>
        )}
      />
      <div id="anchor">
        <TrustVoiceSection background="white" />
      </div>
    </>
  );
}
